/*============================================================================
  Featured Collection Slider
==============================================================================*/
// $(window).on('load', function() {
//   var featuredCollectionslider = {
//     init: function(){
//       var f_slider = $('.fc-slider');
      
//       // Ensure the slider exists before initializing
//       if(f_slider.length) {
//         f_slider.flickity({
//           lazyLoad: 2,          
//           imagesLoaded: true,   
//           draggable: true,      
//           prevNextButtons: false,
//           wrapAround: false,    
//           groupCells: true,     
//           cellAlign: 'left',    
//           pageDots: false,     
//           contain: true,       
//           freeScroll: false,   
//           arrowShape: arrowSize
//         });
//       }
      
//       // Custom previous/next button behavior
//       $('.fcw-nav-prev-next').on('click', function(e){
//         e.preventDefault();
        
//         // Check for previous button
//         if($(this).hasClass('fcw-nav-prev')){
//           f_slider.flickity('previous');
//         } else { // Otherwise it's the next button
//           f_slider.flickity('next');
//         }
//       });
//     },
    
//     unload: function($target){
//       var $slider = $target.find('.js-product-slider');
      
//       // Destroy the Flickity instance if it's initialized
//       if ($slider.hasClass('flickity-enabled')){
//         $slider.flickity('destroy');
//       }
//     }
//   };

//   // Initialize the slider on window load
//   featuredCollectionslider.init();
// });

// // instafeed placeholder slider
// var instaSlider = {
//   init: function(){
//     var insta_slider = $('.insta-feed-placeholder-wrapper');
//     insta_slider.flickity({
//       "lazyLoad": 2,
//       "imagesLoaded": true,
//       "draggable": true,
//       "prevNextButtons": false,
//       "wrapAround": true,
//       "cellAlign": 'left',
//       "pageDots": true,
//       "contain": true,
//       "groupCells": true,
//       "groupCells": 2,
//       "freeScroll": false
//     });
//   },
//   unload: function($target){
//     var $slider = $target.find('.js-product-slider');
//     if ($slider.hasClass('flickity-enabled')){
//       $slider.flickity('destroy');
//     }
//   }
// }

// // Account - What's On Rewards Slider
// var whatsOnRewardsSlider = {
//   init: function(){
//     var wo_slider = $('.whats-on-slider');
//     wo_slider.flickity({
//       "lazyLoad": 2,
//       "imagesLoaded": true,
//       "draggable": true,
//       "prevNextButtons": true,
//       "wrapAround": false,
//       "groupCells": true,
//       "cellAlign": 'left',
//       "pageDots": false,
//       "contain": true,
//       "freeScroll": false,
//       "arrowShape": arrowSize
//     });
//   },
//   unload: function($target){
//     var $slider = $target.find('.js-product-slider');
//     if ($slider.hasClass('flickity-enabled')){
//       $slider.flickity('destroy');
//     }
//   }
// }

// $(function() {
//   // featuredCollectionslider.init();
//   instaSlider.init();
//   whatsOnRewardsSlider.init();

//   // related products slider
//   $('.rps-nav-prev-next').on('click', function(e){
//     e.preventDefault();
//     var $slider = $(this).closest('.related_product-wrapper').find('.products-slider');
//     if($(this).hasClass('rps-nav-prev')){
//       $slider.flickity('previous');
//       if($('#cross-sell').length > 0){
//         $('.cross-sell button.previous').trigger('click');
//       }
//     }else{
//       $slider.flickity('next');
//       if($('#cross-sell').length > 0){
//         $('.cross-sell button.next').trigger('click');
//       }
//     }
//   });
// });

// $(document).ready(function () {
//   $(".header-wrapper .header").before($(".announcement-bar"));

  
  
//   //Annoucement bar slick js
//   $('.announcement-bar-wrapper').slick({
//     vertical: true,
//     slidesToShow: 1,
//     autoplay: true,
//     autoplaySpeed: 5000,
//     infinite: true,
//     pauseOnHover: false,
//     arrows: false,
//     prevArrow: $('.announcement-prev'),
//     nextArrow: $('.announcement-next'),
//     dots: false
//   });
// });


/*============================================================================
  Featured Collection Slider
==============================================================================*/
var featuredCollectionslider = {
  init: function(){
    var f_slider = $('.fc-slider');
    
    // Ensure the slider exists before initializing
    if(f_slider.length) {
      f_slider.flickity({
        lazyLoad: 2,          
        imagesLoaded: true,   
        draggable: true,      
        prevNextButtons: false,
        wrapAround: false,    
        groupCells: true,     
        cellAlign: 'left',    
        pageDots: false,     
        contain: true,       
        freeScroll: false,   
        arrowShape: arrowSize
      });
    }
    
    // Custom previous/next button behavior
    $('.fcw-nav-prev-next').on('click', function(e){
      e.preventDefault();
      
      // Check for previous button
      if($(this).hasClass('fcw-nav-prev')){
        f_slider.flickity('previous');
      } else { // Otherwise it's the next button
        f_slider.flickity('next');
      }
    });
  },
  
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    
    // Destroy the Flickity instance if it's initialized
    if ($slider.hasClass('flickity-enabled')){
      $slider.flickity('destroy');
    }
  }
};

// Move initialization to the document ready event
$(document).ready(function() {
  // Initialize the slider on window load
  featuredCollectionslider.init();

  // instafeed placeholder slider
  var instaSlider = {
    init: function(){
      var insta_slider = $('.insta-feed-placeholder-wrapper');
      insta_slider.flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: true,
        prevNextButtons: false,
        wrapAround: true,
        cellAlign: 'left',
        pageDots: true,
        contain: true,
        groupCells: true,
        freeScroll: false
      });
    },
    unload: function($target){
      var $slider = $target.find('.js-product-slider');
      if ($slider.hasClass('flickity-enabled')){
        $slider.flickity('destroy');
      }
    }
  };

  // Account - What's On Rewards Slider
  var whatsOnRewardsSlider = {
    init: function(){
      var wo_slider = $('.whats-on-slider');
      wo_slider.flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: true,
        prevNextButtons: true,
        wrapAround: false,
        groupCells: true,
        cellAlign: 'left',
        pageDots: false,
        contain: true,
        freeScroll: false,
        arrowShape: arrowSize
      });
    },
    unload: function($target){
      var $slider = $target.find('.js-product-slider');
      if ($slider.hasClass('flickity-enabled')){
        $slider.flickity('destroy');
      }
    }
  };

  // Initialize sliders
  instaSlider.init();
  whatsOnRewardsSlider.init();

  // related products slider
  $('.rps-nav-prev-next').on('click', function(e){
    e.preventDefault();
    var $slider = $(this).closest('.related_product-wrapper').find('.products-slider');
    if($(this).hasClass('rps-nav-prev')){
      $slider.flickity('previous');
      if($('#cross-sell').length > 0){
        $('.cross-sell button.previous').trigger('click');
      }
    }else{
      $slider.flickity('next');
      if($('#cross-sell').length > 0){
        $('.cross-sell button.next').trigger('click');
      }
    }
  });
});

// Side cart
$(function(){
  $('.side-cart-close').on('click', function(){
    $('.side-cart').removeClass('side-cart-opened');
    $('body').removeClass('popup-opened');
  });

  $('.header-cart-icon').on('click', function(e){
    e.preventDefault();
    $('.js-side-cart').addClass('side-cart-opened');
    $('body').addClass('popup-opened');
  });

  $('.account-login-drawer').on('click', function(e){
    e.preventDefault();
    $('.js-side-login').addClass('side-cart-opened');
    $('body').addClass('popup-opened');
  });

  $('.header-account-login').on('mouseover', function(e){
    e.preventDefault();
    $('body').addClass('megamenu-opened');
    $('.customer-account-dropdown').addClass('active');
  });

  $('.nav-menu_right').on('mouseleave', function(e){
    e.preventDefault();
    $('body').removeClass('megamenu-opened');
    $('.customer-account-dropdown').removeClass('active');
  });
  
  $('.nav-search-icon').on('click', function(e){
    e.preventDefault();
    $('.js-side-search').addClass('side-cart-opened');
    $('body').addClass('popup-opened');
  });

  $('.scpi-add').on('click', function(e){
    $(this).next().slideToggle();
  });
});

// instant search function
$(function(){

  var currentAjaxRequest = null;
  var shopURL = $('body').data('shop-url');
  var searchPath = shopURL + '/search?type=product&q=';
  var searchForm = $(".search_side-form");

  //Submit wildcard searches
  searchForm.on("submit", function(e){
    var formValue = $(this).find('input[name="q"]').val();
    var cleanFormValue = encodeURI(formValue);

    e.preventDefault();

    if(cleanFormValue == null) {
      window.location.href = '/search';
    } else {
      window.location.href = searchPath + cleanFormValue + '*';
    }
  }); 

  var input = searchForm.find('input[name="q"]');

  var search_results = $('.search-result-wrapper');

  input.attr('autocomplete', 'off').on('input', function() {

    search_results.hide();
    search_results.empty();

    var term = $(this).val();
    var cleanTerm = encodeURI(term);

    var form = $(this).closest('form');
    var searchURL =  searchPath + cleanTerm;

    var resultsList = search_results;

    if (term.length >= 3) {

      if (currentAjaxRequest != null) currentAjaxRequest.abort();

      $.ajax({
        dataType: "json",
        url: searchURL +'*&view=json',
        beforeSend: function(){
          $('.search-result-loader').show();
        },
        success: function(data){
          resultsList.empty();
          $('.search-result-loader').hide();

          // If we have no results.
          if(data.results_count == 0) {
            resultsList.hide();
            $('.search-result-loader').hide();
            resultsList.append('<p>Sorry no products found.</p>');
          } else {
            // If we have results.
            $.each(data.results, function(index, item) {
              if(index >= 4) {
                return false;
              }

              var link = $('<a></a>').attr('href', item.url);

              //Collect collection handles if product
              if(item.object_type == 'product') {

                var collectionHandles = [];
                for(i=0; i < item.collections.length; i++) {
                  collectionHandles.push(item.collections[i].handle);
                }

                if($.inArray('coming-soon', collectionHandles) != -1) {
                  var itemPrice = "Coming Soon";
                } else {
                  if(item.available == true) {

                    if(item.raw_compare > item.raw_price ) {
                      var itemPrice = '<span class="was_price">' + item.compare + '</span> ' + item.price;
                    } else {
                      if(item.price_varies && item.price_min > 0) {
                        var itemPrice = "from" + ' ' + item.price;
                      } else if(item.price > 0 || item.raw_price > 0) {
                        var itemPrice = item.price;
                      } else {
                        var itemPrice = 'Price TBD';
                      }
                    }
                  } else {
                    var itemPrice = "Sold Out";
                  }
                }

                var item_thumbnail  = item.thumbnail.replace("_200x", "_400x").replace('http:', '');

                if(item.thumbnail != 'NULL') {
                  link.append('<div class="search-result-thumbnail"><img class="lazyload blur-up" src="' + item_thumbnail + '" /></div>');
                }
                link.append('<div class="search-result-title">' + item.title.substring(0,20) + '<span class="item-pricing">'+ itemPrice +'</span></div>');


              }

              link.wrap('<li class="item-result result--' + item.object_type + '"></li>');
              resultsList.append(link.parent());
            });
            // The Ajax request will return at the most 5 results.
            // If there are more than 5, let's link to the search results page.
            if(data.results_count >= 4) {
              resultsList.append('<li class="all-results"><span class="title see-all"><a href="' + searchURL + '*">' + "View all results" + ' (' + data.results_count + ')</a></span></li>');
            }
            resultsList.fadeIn(200);
          }
        }
      });
    }
  });

});

//side content hide
$(function(){
  $(document).mouseup(function (e){

    var container = $(".side-cart-container");

    if (!container.is(e.target) && container.has(e.target).length === 0){

      container.parent().removeClass('side-cart-opened');
      $('body').removeClass('popup-opened');

    }
  });
});

// essential slider
$(function(){
  var essential_slide = $('.essential-slide').flickity({
    "lazyLoad": 2,
    "imagesLoaded": true,
    "draggable": true,
    "prevNextButtons": true,
    "wrapAround": true,
    "cellAlign": 'left',
    "pageDots": false,
    "contain": true,
    "freeScroll": false
  });
});

// Product template
// $(function(){
//   $('.pd-tab').on('click', function(e){
//     e.preventDefault();
//     var parent = $(this).closest('.product-description-wrapper');
//     var target = $(this).attr('href');
//     parent.find('.pd-tab.active').removeClass('active');
//     $(this).addClass('active');

//     parent.find('.tab-content.active').removeClass('active');
//     $(target).addClass('active');
//   });

//   $('.sizeguide-trigger,.material-trigger').on('click', function(e){
//     e.preventDefault();
//     $('.js-side-product-info').addClass('side-cart-opened');
//     $('body').addClass('popup-opened');
//   });

// });

$(document).on("click",".product-details-sidebar-trigger",function(){
  $('.js-side-product-info').addClass('side-cart-opened');
  $('body').addClass('popup-opened');
});
$(document).on("click",".side-cart-close",function(){
  $('.js-side-product-info').removeClass('side-cart-opened');
  $('body').removeClass('popup-opened');
});
$(document).on('click','.pd-tab', function(e){
  var parent = $(this).closest('.product-description-wrapper');
    var target = $(this).attr('href');
    parent.find('.pd-tab.active').removeClass('active');
    $(this).addClass('active');

    parent.find('.tab-content.active').removeClass('active');
    $(target).addClass('active');
});

// collection template
$(function(){
  $('.collection-filter-select span').on('click', function(){
    $('.sidebar').toggleClass('sidebar-opened');
    $(this).removeClass('active');
    $(this).siblings('span').addClass('active');
  });
  $('.sidebar-close').on('click', function(){
    $(this).closest('.sidebar').removeClass('sidebar-opened');
    $('.collection-filter-select span').trigger('click');
  });
  $('body').on('click','.collection_swatches a.swatch', function(e){
    e.preventDefault();
    var swatch_list = $(this).closest('.collection_swatches');
    swatch_list.find('a.swatch').removeClass('active');
    $(this).addClass('active');
    var optionVal = $(this).data('val');
    $(this).siblings('.collection-swatch-title').text(optionVal);

    var selectedProduct = $(this).closest('.collection_swatches').data('product');
    var $product_media = selectedProduct.media;
    var i = 0;
    var swatch_img = '';
    var thumbnail = $(this).closest('.thumbnail');

    $product_media.forEach(function(val,index){
      var img_100x = val.src.replace(/(\.[^.]*)$/, "_100x$1").replace('http:', '');
      var img_200x = val.src.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
      var img_400x = val.src.replace(/(\.[^.]*)$/, "_400x$1").replace('http:', '');
      var img_600x = val.src.replace(/(\.[^.]*)$/, "_600x$1").replace('http:', '');
      var img_800x = val.src.replace(/(\.[^.]*)$/, "_800x$1").replace('http:', '');
      var img_1200x = val.src.replace(/(\.[^.]*)$/, "_1200x$1").replace('http:', '');
      var img_2000x = val.src.replace(/(\.[^.]*)$/, "_2000x$1").replace('http:', '');

      if(val.alt != undefined){
        if(val.alt.includes(optionVal)){
          i++;
          if(i == 1){
            swatch_img = '<div class="image__container lazyload" data-bgset="' + img_2000x + ', ' + img_1200x + ' ,' + img_800x + ',' + img_600x + ', ' + img_400x + ' ,' + img_200x + '" data-sizes="100vw">';
          }else if(i == 2){
            swatch_img += '<img src="' + img_800x + '" class="secondary lazyload fadeIn animated" alt="{{ alt_text | escape }}" />';
            return false;
          }
        }
      }
    });

    if(swatch_img != ''){
      thumbnail.find('.product_image a.product_image_wrap').empty();
      thumbnail.find('.product_image a.product_image_wrap').html(swatch_img);
    }
  });
})

//Smooth scroll effect
$(function(){
  var winScrollTop=0;

  $.fn.is_on_screen = function(){    
    var win = $(window);
    var viewport = {
      top : win.scrollTop(),
      left : win.scrollLeft()
    };
    //viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    //bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
  };

  function parallax() { 
    var scrolled = $(window).scrollTop();
    $('.parallax-section').each(function(){ 
      var speed = $(this).data('parallax-speed');
      if ($(this).is_on_screen()) {	
        var firstTop = $(this).offset().top; 
        var moveTop = (firstTop-winScrollTop) * speed //speed;
        $(this).css("transform","translateY("+-moveTop+"px)");
      }

    });
  }

  $(window).scroll(function(e){
    winScrollTop = $(this).scrollTop();
    parallax();
  });
});

// featured collection tab
$(function(){
  //   $('.fc-list a').on('click', function(e){
  //     e.preventDefault();
  //     var target = $(this).attr('href');
  //     $('.fc-list li').removeClass('active');
  //     $(this).parent().addClass('active');

  //     $('.fcw-content .fc-tab-content').removeClass('active');
  //     $(target).addClass('active');

  //     $('.fc-preview-slider').flickity({
  //       "lazyLoad": 2,
  //       "imagesLoaded": true,
  //       "draggable": true,
  //       "prevNextButtons": false,
  //       "wrapAround": true,
  //       "cellAlign": 'left',
  //       "pageDots": true,
  //       "contain": true,
  //       "freeScroll": false,
  //       "arrowShape": arrowSize
  //     });
  //   });

  //Featured collection recently viewed
  if ($('#fc-tab-content-preview').length){
    var productHandle = "";
    var rvCookie = Cookies.get('recentlyViewed');
    var rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    if(rvProducts){
      var rvProductArray = unescape(rvProducts).split(',');
      var productLimit = $('#fc-tab-content-preview').data('visible-products');
    }
    if (productLimit && rvProductArray){
      rvProductArray = rvProductArray.slice(0, productLimit);
    }
    $.each(rvProductArray, function (index, value) {
      if (value){
        $.ajax({
          type: 'GET',
          url: '/products/' + value  + '.js',
          success: function(data) {
            if(data){
              var r_product = '<div class="fc-slider-cell"><a href="' + data.url + '"><div class="fc-slider-img-wrapper blur-up" style="background-image: url(' + data.featured_image.replace(/(\.[^.]*)$/, "_600x$1").replace('http:', '') + ');">';
              r_product += '</div><h3>' + data.title + '</h3></a></div>';
            }
            $('.fc-preview-slider').append(r_product);
          },
          error: function(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
          },
          dataType: "json"
        });
      }
    });    
  }

});

// wishlist js
$(function(){
  $('body').on('click', '.wishlist-sharing span', function(){
    $('.iwishshareWrapper').addClass('show fadeIn');
  });
  $(document).mouseup(function (e){

    var container = $(".iwishShareContainer");

    if (!container.is(e.target) && container.has(e.target).length === 0){

      container.parent().removeClass('show fadeIn');

    }
  });

  $('body').on('click', '.clear-wishlists span', function(){
    $('a.iwishRemoveBtn').trigger('click');
  });

  $(window).on('load', function(){
    if($('.iwishItem').length > 0 ){
      $('.iwishEmpty-content').hide();
    }else{
      $('.iwishEmpty-content').show();
      $('.iwishTitle').hide();
      $('.iwishProducts').hide();
    }
  });

  $(document).mouseup(function (e){
    var iwish_count = $('.iWishCount').text();
    if(iwish_count > 0){
      $('.wish-item-show').show();
    }
  });
});

// Mobile nav script
$(function(){
  $('.nav-toggle-link').on('click', function(e){
    e.preventDefault();
    $('.mobile-header-slide').addClass('active');
    $('body').addClass('popup-opened');
  });

  $('.mhs-close').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('popup-opened');
    $('.mobile-header-slide').removeClass('active');
  });
});

// featured image slider
$(function(){
  $('.fits-content-slider').flickity({
    "lazyLoad": 2,
    "imagesLoaded": true,
    "draggable": true,
    "prevNextButtons": false,
    "wrapAround": true,
    "cellAlign": 'left',
    "pageDots": false,
    "contain": true,
    "freeScroll": false,
    "arrowShape": arrowSize
  });
});

$('.js-blog-product-slider .products-slider').flickity({
  "lazyLoad": 2,
    "imagesLoaded": true,
    "draggable": true,
    "prevNextButtons": false,
    "wrapAround": false,
    "groupCells": true,
    "cellAlign": 'left',
    "pageDots": true,
    "contain": true,
    "freeScroll": false,
    "arrowShape": arrowSize
});

// product page custom script
$(function(){
  $(window).on('load', function(){
    if($('.purchase-details__buttons select').length > 0){
      var po_option = $('.purchase-details__buttons select');
      po_option.val('').change();
    }
  });

  $('.purchase-details__buttons select').change(function(){
    var selected_value = $(this).val();
    if(selected_value != ''){
      $('.selector-wrapper').each(function(){
        var title = $(this).find('label').text().toLowerCase();
        var select = $(this).find('select');
        if(title == 'size'){
          select.val(selected_value).change();
        }
      });
    }
  });

  $('.tab-title-mobile').on('click', function(){
    // $('.tab-content').each(function(){
    //   $(this).removeClass('active');
      
    //     $(this).find('.tab-des-content').slideUp();
    // })
    // $(this).next().slideDown();
    $('.tab-content').each(function () {
        // Check if the current element's content is visible
        if ($(this).find('.tab-des-content').is(':visible')) {
            // Only slide up if it's visible
            $(this).find('.tab-des-content').slideUp();
            $(this).removeClass('active');
        }
    });

    // Slide down the next content only if it's not already visible
    if (!$(this).next().is(':visible')) {
        $(this).next().slideDown();
        $(this).next().addClass('active');
    }
  });

  $('.pbsw-content-bottom').on('click', function(){
    $(this).hide();
    $(this).siblings('.pbsw-content-container').addClass('expanded');
  })

});

//featured-product-slider
$(function(){
  var feature_p_slider = $('.js-featured-product-slider').flickity({
    "lazyLoad": 2,
    "imagesLoaded": true,
    "draggable": true,
    "prevNextButtons": false,
    "wrapAround": true,
    "cellAlign": 'left',
    "pageDots": false,
    "contain": true,
    "freeScroll": false,
    "arrowShape": arrowSize
  });
  
  $('.featured-list-text-slider').each(function(){
    var textSlider = $(this);
  	var textLength = textSlider.find('.featured-list-text-cell').length;
    textSlider.find('.featured-list-text-cell:eq(0)').fadeIn();
    var i = 0;
    setInterval(function(){
      i++;
      textSlider.find('.featured-list-text-cell').fadeOut();
      textSlider.find('.featured-list-text-cell:eq(' + i + ')').fadeIn();
      if(i == textLength - 1){
      	i = -1;
      }
    },2500);
  })
});

//ZM-account page
// jQuery.
$(function() {
  // Reference the tab links.
  const tabLinks = $('#tab-links li a');

  // Handle link clicks.
  tabLinks.click(function(event) {
    var $this = $(this);

    // Prevent default click behaviour.
    event.preventDefault();

    // Remove the active class from the active link and section.
    $('#tab-links a.active, section.active').removeClass('active');

    // Add the active class to the current link and corresponding section.
    $this.addClass('active');
    $($this.attr('href')).addClass('active');
  });

  $('.action_edit').on('click',function(){
    let id = $(this).data('address-id')
    console.log(id)
    $('.account-modal-overlay').show();
    $(`#edit_address_${id}`).show();
  })

  $('.action_add.mobile').on('click',function(){
    $('.account-modal-overlay').show();
    $(`#add-address-modal-mobile`).show();
  })

  $('.action_add.desktop').on('click',function(){
    $('.account-modal-overlay').show();
    $(`#add-address-modal-desktop`).show();
  })

  $('.cancel-add-address-button').on('click',function(){
    $('.account-modal-overlay').hide();
    $(`#add-address-modal-mobile`).hide();
    $(`#add-address-modal-desktop`).hide();
  })

  $('.tab--title').click(function(){
    if($(this).siblings('.tab--content').css('display')=='none'){
      $('.tab--content').slideUp()
      $('.tabs--panel').removeClass('tab--open')
      $(this).parent().addClass('tab--open')
      $(this).siblings('.tab--content').slideDown()

    }else{
      $(this).siblings('.tab--content').slideUp(()=>{
                                                $(this).parent().removeClass('tab--open');
    });
  }
                         });
});

// Footer FUnctionality
$(function(){
  $('.footer_menu_list').on('click', 'a', function(e){
    e.preventDefault();
    var target = $(this).attr('href');
    if(target == '#side-login'){
      $('.js-side-login').addClass('side-cart-opened');
      $('body').addClass('popup-opened');
    }else{
      window.location.href = target;
    }
  });
});

// mobile-mega menu
// $(function(){
//   $('body').on('click', '.mobile-mega-menu-parent', function(){
//     var menu_target = $(this).data('mobile-dropdown-rel');
//     if(menu_target != ''){
//       $('[data-mobile-dropdown=' + menu_target + ']').addClass('active');
//       $('.mhs-nav-wrap').addClass('submenu-opened');
//     }
//   });

//   $('body').on('click', '.mobile-mega-menu-back', function(){
//     $(this).closest('.mobile-mega-menu').removeClass('active');
//     $('.mhs-nav-wrap').removeClass('submenu-opened');
//   });

//   $(window).on('load', function(){
//     $('.mobile-mega-menu').addClass('added');
//   });
// });

//wishlist
document.addEventListener('DOMContentLoaded', (event) => {
  var iwish_count = localStorage.getItem('iWishCnt');
  if(iwish_count > 0){
    $('.wish-item-show').show();
  }
});

// Competition page
$(function(){
  $('.pg-signup a').on('click', function(e){
    e.preventDefault();
    $('.page-giveaway-signup-wrap').addClass('show');
  });

  $(document).mouseup(function (e){
    var container = $(".pg-signup-container");

    if (!container.is(e.target) && container.has(e.target).length === 0){

      container.parent().removeClass('show');

    }
  });
});

// custom product bundle page

var bundleFunction = {
  init: function(){
    $('body').on('change', '[bundle-variant-checkbox]', function(){
    	bundleFunction.bundleOptionchange();
    });
    
    $('body').on('click', '.bundle_size-option', function(){
      var id = $(this).data('id');
      var price = $(this).data('price');
      var parent = $(this).closest('.bundle_list-cell');
      var bundleCheckbox = parent.find('[bundle-variant-checkbox]');
      
      parent.find('.bundle_size-option').removeClass('active');
      $(this).addClass('active');
      bundleCheckbox.data('price', price);
      bundleCheckbox.val(id);
      bundleFunction.bundleOptionchange();
    });
  },
  bundleOptionchange: function(){
    var total_price = 0;
    var i = 0;
    var totalCells = $('.bundle_list-cell').length;
    var discountNote = $('[data-bundle-discount-note]');
    $('.bundle_list-cell').each(function(){
      var $inputPrice = parseInt($(this).find('input[bundle-variant-checkbox]').data('price'));
      if($(this).find('input[bundle-variant-checkbox]').prop('checked')){
        total_price += $inputPrice;
        i++;
      }
    });

    if(i == totalCells){
      //total_price = total_price * 0.85;
      //discountNote.text('(15% discount applied at checkout)');
    }else{
      //discountNote.text('Enjoy 15% off when you get the entire set');
    }

    if(total_price > 0){
      $('.bundle_list-wrap').removeClass('no-selected-bundles');
    }
    $('.product_form').find('.modal_price .current_price').html('<span class="money">' + Shopify.formatMoney(total_price, $('body').data('money-format')) + '</span>');
  }
}

$(function(){
  bundleFunction.init();
})

// Charm connector functionality
var charmConnectorfunction = {
  init: function(){
    var charmselectWrap = $('[data-prodct-charm-cell]');
    var charmselectTitle = $('[data-product-charm-title]');
    var charmselectPrice = $('[data-product-charm-price]');
    var charmSelect = $('[charm-variant-checkbox]');
    var charmSelectImg = $('[data-prodct-charm-cell]').find('img');

    $('body').on('change', '[name="charmConnector"]', function(){
      if($(this).val() != ''){
        var variantId = $(this).val();
        var price = $(this).find('option:selected').data('price');
        var title = $(this).find('option:selected').data('title');
        var img = $(this).find('option:selected').data('image');

        charmselectTitle.text(title);
        charmselectPrice.text(price);
        charmSelect.prop('checked', true);
        if(img != ''){
          charmSelectImg.attr('src',img);
        }

        $('.product-charm-selector-wrap').hide();
        $('.product-charm-selected-list').show();
      }
    });
    
    $(window).on('load', function(){
      if($('.charmSelector').length > 0){
      	var $height = $('.charmSelector').height();
        $('.charmSelector').closest('.product-charm-selector-options').css({'min-height': $height + 2 + 'px'});
      }
    })

    charmSelect.on('change', function(e){
      if($(this).prop('checked')){

      }else{
        $('.product-charm-selector-wrap').show();
        $('.product-charm-selected-list').hide();
        $('.charmSelector').find('span').text('Please select your item');
        $('[name="charmConnector"]').val('').change();
      }
    })
    
    $('body').on('click', '.charmSelector span', function(e){
      $(this).parent().toggleClass('active');
    })
    
    $('body').on('click', '.charmSelector-cell', function(e){
      var value = $(this).data('value');
      $(this).closest('.charmSelector').find('span').html($(this).html());
      $(this).closest('.charmSelector').removeClass('active');
      $('[name="charmConnector"]').val(value).change();
    })
  }
}
$(function(){
  charmConnectorfunction.init();
})

$('.collection-testimonial').slick({
	slidesToShow: 1,
  	slidesToScroll: 1,
  	arrows: false,
  	dots: true
});

$(document).on('click', '.toggle-content', function(event) {
  	event.preventDefault();
  	$(this).toggleClass('content-close');
	$(this).prev('.feature-box').toggleClass('full-height');
});

// Loyalty Lion - Membership Information
function updateMembershipTier(points) {
  if (points <= 1999) {
    var nextTierPoints = 2000 - points;
    $('.tier-name').text('Pearl Ambassador');
    $('.membership-progress').attr( "value", points);
    $('.next-tier-points').text(nextTierPoints);
  } else if (points >= 2000) {
      $('.tier-name').text('Pearl Icon');
      $('#membership-progress').attr( "value", points);
      $('.membership-next-tier').css('display', 'none');
    }
}

const membershipPoints = document.querySelector('.membership-points');

var observer = new MutationObserver(function(e) {
    var pointsStr = $('.membership-points:first').text().replace(',', '');
    var points = parseInt(pointsStr);

    updateMembershipTier(points)
    
});

// observer.observe(membershipPoints, { 
//   childList: true
// });

// Loyalty Lion - Add "Completed" after Sign Up Rewards
const loyaltyLion = document.querySelector(".ll-container");

var observer = new MutationObserver(function(e) {
  $( ".lion-rule-item--signup .lion-rule-item__actions" ).append( '<button class="lion-action-button lion-action-button--tile lion-action-button--disabled lion-action-button--completed"><span class="lion-rule-item__completed">Completed</span></button>' ); 
});

// observer.observe(loyaltyLion, { 
//   childList: true
// });

 // Header - Hide Scroll Down - Show Scroll Up
 // Have commented out the cloning of Header in app.js
$(function(){
 $(window).on("scroll", function() {
    if($(window).scrollTop() > 140) {
        $("#shopify-section-header").hide();
    } else {
      $("#shopify-section-header").show();
    }
  });

  var lastScroll = 0;
  $(window).on('scroll',function() {    
      var scroll = $(window).scrollTop();
      if(lastScroll - scroll > 0) {
          $("#shopify-section-header").addClass("active");
      } else {
          $("#shopify-section-header").removeClass("active");
      }
      lastScroll = scroll;
  });
});


// Account - New Address Button
$('.add-address-button').on('click', function() {
  $('.add-address-form').addClass('active');
  $(this).removeClass('active');
});

$('.cancel-add-address-button').on('click', function() {
  $('.add-address-form').removeClass('active');
  $('.add-address-button').addClass('active');
});

// HEADER CONTACT PANEL
$(function(){
  $('.toggle-contact-panel').on('mouseover', function(e){
    e.preventDefault();
    $('.contact-panel').show();
    $('body').addClass('megamenu-opened');
  });

  $('.toggle-contact-panel').on('mouseleave', function(e){
    e.preventDefault();
    $('.contact-panel').hide();
    $('body').removeClass('megamenu-opened');
  });
});

/* LOVE NOTE */
$(function(){
  $(document).on('click', '.glproGiftOptionsPageEleInnerEle', function() {
    $('.giftWrapBody .glproGiftWrapMainContent').html('<video width="100%" controls><source src="https://cdn.shopify.com/videos/c/o/v/db817884e53d4cae898ef1dd5730cc84.mp4" type="video/mp4"></video><div class="loveletter-popup-text">- We’re offering you the chance to send your loved one a surprise digital e-note with your gift<br />- Write your message and choose a delivery date<br />- Your love note will land in their inbox on your chosen date<br />- We’ll also give them a hint that they have a gift coming their way from Olivia & Pearl!<br />- Your note will be added to your order, please add your gift to your bag and checkout as normal<br />- Please note - your e-note won\'t show at checkout, but rest assured it will be sent with your order</div>');
  });
});

$(document).on('click', '.lovenote-btn', function(event) {
  	event.preventDefault();
  	$('.glproGiftOptionsPageEleInnerEle').click();
});

$(document).on('click', '.giftMessageFinalButton', function() {
  setTimeout(() => {
    if ( $('.glproModalWrapper').is(':hidden')) {
      $('.loveletter-thankyou-wrapper').fadeIn();
      setTimeout(() => {
        $('.loveletter-thankyou-wrapper').fadeOut();
      }, '3500');
    }
  }, '1800');
});

document.addEventListener('DOMContentLoaded', function() {
    // Function to add 'added' class to mobile mega menus
    function addAddedClassToMegaMenus() {
        var mobileMegaMenus = document.querySelectorAll('.mobile-mega-menu');
        mobileMegaMenus.forEach(function(menu) {
            menu.classList.add('added');
        });
    }

    // Event delegation for mobile mega menu parent
    document.body.addEventListener('click', function(e) {
        if (e.target.matches('.mobile-mega-menu-parent')) {
            var menuTarget = e.target.dataset.mobileDropdownRel;
            if (menuTarget !== '') {
                var dropdown = document.querySelector('[data-mobile-dropdown="' + menuTarget + '"]');
                if (dropdown) {
                    dropdown.classList.add('active');
                }
                document.querySelector('.mhs-nav-wrap').classList.add('submenu-opened');
            }
        }
    });

    // Event listener for mobile mega menu back
    document.body.addEventListener('click', function(e) {
        if (e.target.matches('.mobile-mega-menu-back')) {
            var mobileMegaMenu = e.target.closest('.mobile-mega-menu');
            if (mobileMegaMenu) {
                mobileMegaMenu.classList.remove('active');
            }
            document.querySelector('.mhs-nav-wrap').classList.remove('submenu-opened');
        }
    });

    // Add 'added' class to mobile mega menus when the page loads
    addAddedClassToMegaMenus();  // Call the function to add the class
});


$(document).ready(function () {
  //********** PDP details sidebar *****************//
  if($(".swatch_options").length > 0 && $(".product-details-sidebar").length > 0){
    $(".product-details-sidebar").appendTo(".swatch-material");
  }

  //Print Bundle variant ID on load
  function changeVariant(element) {
      // Initialize an empty array to store selected values from all fieldsets
      var selectedValues = [];
      var ajaxSubmit = $(".ajax-submit");
      var addCartText = ajaxSubmit.attr("data-label");
      var soldOutText = ajaxSubmit.attr("data-sold-out-label");
      // Loop through each fieldset within the '.quickview-variants-wrapper'
      $(".bundle-product-variant-container .swatch-wrapper").each(function() {
          // Find the active label and get its 'data-value' attribute
          var activeInput = $(this).find("input:checked");
          var activeValue = activeInput.val() || "";
          if (activeValue) {
            selectedValues.push(activeValue); // Add the active value to the array
          }
      });
      // Join the selected values with " / " separator
      var comb = selectedValues.join(" / ");
      
      // Find the variant based on the combined value
      var selector = "[variant-title='" + comb + "']";
      var selectedvaraintData = $(".bundle-product-variant-container").find(".all_variants " + selector);
      var selectedVariantID = selectedvaraintData.data("variant-id");
      var selectedVariantComparePrice = selectedvaraintData.data("variant-compare-price");
      var selectedVariantPrice = selectedvaraintData.data("variant-price");

      // If a variant ID is found, set it in the data-id of the closest label for each checked input
      if (selectedVariantID) {
        element.attr("data-id", selectedVariantID);
         // Trigger the option in the select dropdown to match the selectedVariantID
        $(".shopify-product-form .multi_select").val(selectedVariantID).trigger("change");
       console.log("selectedVariantID ",selectedVariantID);
      }
    
      //Check if variant is out of stock
      if(selectedvaraintData.hasClass("out-of-stock")){
        ajaxSubmit.addClass("disabled").attr("disabled", true).text(soldOutText);
        $(".klaviyo-bis-trigger").show();
        $(".modal_price .sold_out").text("Sold Out");
        $(".modal_price .variant-avility-state").text("Out Of Stock");
        $(".product-compare-price").text('');
        $(".product-regular-price").text('');
        $(".modal_price").addClass('out-stock-variant');
      }
      else{
        ajaxSubmit.removeClass("disabled").removeAttr("disabled").text(addCartText);
        $(".klaviyo-bis-trigger").hide();
        $(".modal_price .sold_out").text('');
        $(".modal_price .variant-avility-state").text('');

        //Update the price 
        if(selectedVariantPrice != ''){
          $(".product-compare-price").html('<span class="money">' + selectedVariantComparePrice + '</span>');
        }
        $(".product-regular-price").html('<span class="money">' + selectedVariantPrice + '</span>');
        $(".modal_price").removeClass('out-stock-variant');
      }
  }
  
  // Bind the function to the change event of `.swatch-wrapper label`
  $(document).on("click",".bundle-product-variant-container .swatch-wrapper .swatch-element", function () {
    var clickedElement = $(this);
    setTimeout(function () {
      changeVariant(clickedElement);
      // updateBundleProductTitle();
    }, 500);
  });
  
  //Update the bundle product title as variant Title
   function updateBundleProductTitle() {
     var checkedVarianTitle = $(".bundle-product-variant-container .visible-swatch-warpper input:checked").val();
    // $(".bundle-product-variant-container .material-label").each(function () {
    //     var bundleName = $(this).data("bundle-name"); // Get the value of the 'data-bundle-name' attribute
    //     $(this).text(bundleName); // Set the text of the current element
    // });
     console.log("checkedVarianTitleeee ",checkedVarianTitle);
     $(".bundle-product-variant-container .visible-swatch-warpper .material-label").text(checkedVarianTitle);
  }

  updateBundleProductTitle();

  if($(".bundle-product-main").length > 0){
    var bundleProductMain = $(".bundle-product-main").detach();
    if ($(".purchase-details").length > 0) {
      $(".purchase-details").after(bundleProductMain); // Append the detached element below .purchase-details
    }
  }

  // Trigger Hidden Bundle Product Variants Based on first bundle item Selection
  $(document).on("click", ".bundle-product-variant-container .visible-swatch-warpper .swatch-element", function () {
      var selectedBundleOption = $(this).attr("data-bundle-option-index"); // The clicked element
       // Loop through all hidden `.swatch-wrapper` elements
      $(".bundle-product-variant-container .hidden-swatch-wrapper").each(function () {
          // Find the input with the same index as the clicked input
          var correspondingInput = $(this).find("[data-bundle-option-index='" + selectedBundleOption + "']");
          console.log("correspondingInput ",correspondingInput);
          // Trigger the click event on the corresponding input
          correspondingInput.find("label").trigger("click");
      });
  
      // // Handle the variant change for the clicked input
      // setTimeout(function () {
      //     changeVariant(clickedElement);
      // }, 500);

    //Update bundle product variant title
    setTimeout(function () {
      updateBundleProductTitle();
    }, 100);
  });

  // bundle variant image content add js
  function updateVariantImage() {
    var selectedInputValue = $(".bundle-variant-image .swatch-wrapper input:checked").val();
    
    var $matchedInput = $(".visible-swatch-warpper [data-value='" + selectedInputValue + "']");
    setTimeout(function() {
      $matchedInput.find("label").trigger("click");
    }, 100);
    
    // Update the variant title with the selected value after a slight delay
    if (selectedInputValue) {
        setTimeout(function() {
            $(".variant-title-name").text(selectedInputValue);
        }, 10);
    }
  }
  
  $(document).on("change",".bundle-variant-image .swatch-wrapper input:checked",function(){
    updateVariantImage();
  });
  
  updateVariantImage();

  
  if($(".bundle-variant-image").length > 0 && $(".modal_price").length > 0){
    $(".modal_price").after($(".bundle-variant-image"));
  }

  //Remove blocked-scroll from body on drawer close click event
  $(document).on("click", ".upcart-header-close-button", function () {
    $('body').removeClass('blocked-scroll');
  });

  //****************************** START code for Discount bundle ***********************
  var bundleInterval = setInterval(function () {
      if($(".fbp-vbw-container").length > 0) {
        let setDateAppend = $(".icon-with-deacritpion");
        $(".fbp-vbw-atc-button-disclaimer").before(setDateAppend);
        
        var bundleData = $(".fbp-vbw-container");
        $(".new-product-description").after(bundleData);
        $(".product-info-container .swatch_options").hide();
        $(".product-info-container .purchase-details").hide();
        $(".fbp-vbw-container").css("display","flex");
        
        // Get the product title
        var productTitle = $('.product-bundle-title').text();
        // Find each .fbp-vbw-tier-container
        $(".fbp-vbw-tier-container").each(function(index) {
            // Find the .fbp-vbw-discount-title within the current .fbp-vbw-tier-container
            var discountBundleTitle = $(this).find(".fbp-vbw-discount-title");
            // Append a new span around the product title text
            var indexCounter = $(this).attr("data-quantity");
            discountBundleTitle.after('<span class="discount_bundle_title">' + indexCounter + ' x ' + productTitle + '</span>');
            $(this).find(".fbp-vbw-discount-percentage").prepend('<span class="fbp-save-text">Save </span>');
            $(this).find(".fbp-vbw-variant-picker-container select").each(function (selectIndex) {
              $(this).before('#'+(selectIndex + 1)+' ');
            });
      
            var fbpOffText = $(this).find(".fbp-vbw-discount-percentage").text();
            if (fbpOffText.includes('off')) {
              var newText = fbpOffText.replace('off', '').trim();
              $(this).find(".fbp-vbw-discount-percentage").text(newText);
            }

          //Append custom product variant dropdown
          var selectElements = $(this).find(".fbp-vbw-variant-picker-container select");

          //Iterating Through Bundle App Select Dropdown Elements
          selectElements.each(function(selectIndex, selectData) {
            //Get the first select option 
            var firstOptionVal = $(selectData).find("option").first().text();
            var firstOptionValWithoutVermeil = firstOptionVal.replace(/Vermeil/i, "").replace(/18ct/i, "");
            var firstOptionValformattedText = firstOptionVal.split(/\s+/).map(function(item) {
                    return item.trim().toLowerCase();
                }).filter(function(item) {
                    return item !== "";
                }).join("-"); 
            
            $(this).attr("data-fbp-dropdown-index",selectIndex); // Add index in default select
            
            var customSelectDrodpdownData = $(`<div class="fbp-custom-variant-dropdown" data-dropdown-index="${selectIndex}">
                                <span class="fbp-custom-variant-dropdown-toggleclass">
                                  <span class="option-material-${firstOptionValformattedText} fbp-vbw-variant-option-material"></span>
                                  <span class="fbp-vbw-variant-picker-name">${firstOptionValWithoutVermeil}</span>
                                </span>
                                <div class="fbp-custom-variant-dropdown-wrapper"></div>
                               </div>`);
            
            // Append Options 
            var optionElements = $(this).find("option");
            optionElements.each(function(optionIndex) {
              var optionValue = $(this).val();
              var selectOptionText = $(this).text();
              var selectOptionTextTrim = selectOptionText.replace(/Vermeil/i, "").replace(/18ct/i, "");
              var formattedText = selectOptionText.split(/\s+/).map(function(item) {
                    return item.trim().toLowerCase();
                }).filter(function(item) {
                    return item !== "";
                }).join("-"); 
              var variantHtml = `
                <span data-variant-value="${optionValue}" class="fbp-vbw-variant-wrapper">
                  <span class="option-material-${formattedText} fbp-vbw-variant-option-material"></span>
                  <span class="fbp-vbw-variant-picker-name">${selectOptionTextTrim}</span>
                </span>
              `;
              customSelectDrodpdownData.find('.fbp-custom-variant-dropdown-wrapper').append(variantHtml);
            });
            $(this).closest(".fbp-vbw-variant-picker-container select").after(customSelectDrodpdownData);
          });
        });  

        //Trigger FBP Bundle Select Option Trigger on Custom select options Click
        $(document).on("click",".fbp-custom-variant-dropdown .fbp-vbw-variant-wrapper",function(){
          var fbpCustomVariant = $(this).attr("data-variant-value");
          var fbpCustomVariantIndex = $(this).closest(".fbp-custom-variant-dropdown").attr("data-dropdown-index");
          $(this).closest(".fbp-vbw-variant-picker-container").find("select[data-fbp-dropdown-index="+fbpCustomVariantIndex+"] option[value="+fbpCustomVariant+"]").prop("selected", true).trigger("change");
          var fbpCustomVariantAdd = $(this).html();
          $(this).closest(".fbp-custom-variant-dropdown").find(".fbp-custom-variant-dropdown-toggleclass").html(fbpCustomVariantAdd);
          var self = this;
          setTimeout(function () {
            $(self).closest(".fbp-custom-variant-dropdown").removeClass("active");
          }, 50);
        });

        //Remove Toggleclass
        $(document).on("click", function (e) {
          if (!$(e.target).closest(".fbp-custom-variant-dropdown-toggleclass").length) {
              $(".fbp-custom-variant-dropdown").removeClass("active");
          }
        });

        //Toggleclass click event
         $(document).on("click",".fbp-custom-variant-dropdown-toggleclass",function(){
           $(".fbp-custom-variant-dropdown").not($(this).closest(".fbp-custom-variant-dropdown")).removeClass("active");
          $(this).closest(".fbp-custom-variant-dropdown").toggleClass("active");
        });
        
        clearInterval(bundleInterval);
      }
  }, 100);

  setTimeout(function () {
    clearInterval(bundleInterval);
  }, 3000);
  //****************************** END code for Discount bundle ***********************

  // ************** START ajax add to cart buton
  $(document).on("click",".ajax-add-to-cart", function () {
    var variantID = $(this).attr("data-variantid");
    addToCartJS(1,variantID);
  });

  function addToCartJS(qty,variantID) {
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
         // window.location.href="/cart";
      }
    };
    var data = JSON.stringify({"quantity": qty, "id": variantID });
    xhr.send(data);
  }
  
  // ************** END ajax add to cart buton


  // START variant change event
   $(document).on("click", ".product-ajax-swatch", function () {
      let variantID = $(this).attr("data-variantid");
      let variantImage = $(this).attr("data-variant-image");
      let variantPrice = $(this).attr("data-variant-price");
  
      let $productWrapper = $(this).closest(".product-main-wrapper");
  
      if (variantID !== undefined) {
        $productWrapper.find(".ajax-add-to-cart").attr("data-variantid", variantID);
      }
      if (variantImage !== undefined) {
        if ($productWrapper.find(".product_image_wrap .image__container").length > 0) {
            $productWrapper.find(".product_image_wrap .image__container").css("background-image", `url(${variantImage})`);
        } else {
            $productWrapper.find(".product_image_wrap img").attr("src", variantImage);
        }
      }
      if (variantPrice !== undefined) {
        $productWrapper.find(".data-variant-price").text(variantPrice);
      }
  });
  // END variant change event
  
  //  START set start date to end date
  var currentDate = new Date();
  var givenDate = $(".icon-with-content .set-date").attr("data-date");
  
  // Add the given number of days from the data-date to the current date
  currentDate.setDate(currentDate.getDate() + parseInt(givenDate));
  
  // Create a copy of the current date for the end date (after 3 more days)
  var endDate = new Date(currentDate);
  endDate.setDate(endDate.getDate() + 3); // Adds 3 more days for the end date
  
  // Function to format just the day with a suffix (st, nd, rd, th)
  function formatDay(date) {
    const dayNumber = date.getDate();
    const suffix = dayNumber === 1 || dayNumber === 21 || dayNumber === 31 ? 'st' :
                   dayNumber === 2 || dayNumber === 22 ? 'nd' :
                   dayNumber === 3 || dayNumber === 23 ? 'rd' : 'th';
    
    return dayNumber + suffix; // Return the day with suffix
  }
  
  // Get the formatted start day and end day
  var startDay = formatDay(currentDate);
  var endDay = formatDay(endDate);
  
  // Get the month name (we'll use the same month for both)
  const monthOptions = { month: 'long' };
  var endMonth = endDate.toLocaleDateString('en-GB', monthOptions);
  
  // Combine both dates into a range in the "27th - 2nd March" format
  var resultDate = startDay + ' - ' + endDay + ' ' + endMonth;
  
  // Set the result text to the element
  $(".icon-with-content .set-date").text(resultDate);
  //  END set start date to end date

    function closePopup(element) {
      $('body').removeClass('klarna-popup-open');
    }
    $(document).on('click', '.popup-add-event', function () {
        $('body').addClass('klarna-popup-open');
    });
    $(document).on('click', '.popup-close-event' , function() {
        closePopup($(this));
    });

});

// =============== START: Announcement bar Slick slider ===========
function initPDPFeatures() {
  console.log("Init called");

  // Your slick or other JS code goes here
  if ($('.announcement-bar-wrapper').length && !$('.announcement-bar-wrapper').hasClass('slick-initialized')) {
    $('.announcement-bar-wrapper').slick({
      vertical: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      pauseOnHover: false,
      arrows: false,
      dots: false
    });
  }
}

// Run once on DOM ready (live site)
document.addEventListener("DOMContentLoaded", function () {
  initPDPFeatures();
});

// Run again when Shopify dynamically loads sections (Customize mode)
document.addEventListener("shopify:section:load", function () {
  initPDPFeatures();
});
// =============== END: Announcement bar Slick slider ===========

document.addEventListener("shopify:section:select", function () {
  initPDPFeatures();
});

